import logrocket from '@/services/logrocket';

import {
  checkPartnerKey as checkPartnerKeyApi,
  getLocale as getLocaleApi
} from 'services/api/common';

export const checkPartnerKey = async (partnerKey) => {
  try {
    const { data } = await checkPartnerKeyApi(partnerKey);
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export const getLocale = async () => {
  try {
    const { data } = await getLocaleApi();
    return data;
  } catch (error) {
    logrocket.logger(error);
    throw error;
  }
};

export default {
  checkPartnerKey,
  getLocale,
};
